import { createContext } from "react";
import type usePersonnelIdentityById from "src/hooks/data/load/usePersonnelIdentityById";

export interface IPersonnelIdentityContext extends ReturnType<typeof usePersonnelIdentityById> {}

export const PersonnelIdentityContext = createContext<IPersonnelIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default PersonnelIdentityContext;
